import {useEffect, useState} from "react";

interface InputErrorMessageAttributes {
    inputValue: string | boolean,
    validate: (any) => any,
    checkFlag: boolean
}

export default function useInputError({inputValue, validate, checkFlag}: InputErrorMessageAttributes) {
    const [isError, setIsError] = useState(true)
    const [showError, setShowError] = useState(false)

    useEffect(() => {
        setIsError(!validate(inputValue))
    }, [inputValue])

    useEffect(() => {
        if (checkFlag) {
            setShowError(!validate(inputValue))
        }
    }, [checkFlag, inputValue])

    return {isError, showError}
}